import { flightItineraryHelpers } from './base'

const primaryTeal = 'var(--chakra-colors-brand-primaryTeal)'
const alBlack = 'brand.black'
const alCoolGrey10 = 'brand.coolgrey10'

export const FlightItineraryProp = flightItineraryHelpers.defineMultiStyleConfig({
  baseStyle: flightItineraryHelpers.definePartsStyle({
    title: {
      color: primaryTeal,
    },
    departureDateTime: {
      color: alBlack,
    },
    airportName: {
      color: alCoolGrey10,
    },
    terminal: {
      color: alBlack,
    },
    iataCode: {
      color: alBlack,
    },
    flightTime: {
      color: primaryTeal,
    },
    arrow: {
      borderColor: primaryTeal,
    },
    stopCount: {
      color: alBlack,
    },
    layoverInfo: {
      color: primaryTeal,
    },
    directIndicator: {
      color: alCoolGrey10,
    },
    journeyDurationInHoursAndMinutes: {
      color: alCoolGrey10,
    },
    flightClassesAndFlightNumbers: {
      color: alCoolGrey10,
    },
  }),
})
